import { AssetsHelper } from '@/helpers/assetsHelper';
import { UserHelper } from '@/helpers/user.helper';
import { NavService } from '@/services/nav.service';
import { Component, inject } from '@angular/core';

import { AppConfigService } from '@/services/app-config.service';
import { AsyncPipe } from '@angular/common';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterLink } from '@angular/router';
import { MainMenuListComponent } from '../main-menu-list/main-menu-list.component';
import { MainMenuRightComponent } from '../main-menu-right/main-menu-right.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'nav[app-header]',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatBadgeModule,
    MainMenuListComponent,
    RouterLink,
    AsyncPipe,
    MainMenuRightComponent,
  ],
})
export class HeaderComponent {
  private userHelper = inject(UserHelper);
  private navService = inject(NavService);
  private appConfigService = inject(AppConfigService);

  logoPath = '/';
  logo = AssetsHelper.logo;
  isNavigationDisabled = this.userHelper.isRescueService();
  menuOpened$ = this.navService.mainMenuOpened;

  hideMenu = false;

  constructor() {
    this.hideMenu = this.appConfigService.isMobileOrTablet;
  }

  onClickMenuBtn() {
    this.navService.toggleMainMenu();
  }
}
